<template lang="html">
  <div class="default-container">
    <img v-if="!theme_switch" :src="$store.state.static_img_url + 'pic/quesheng-1.png'">
    <img v-else :src="$store.state.static_img_url + 'pic/quesheng-2.png'">
    <slot name="p">
    </slot>
  </div>
</template>

<script>
export default {
  computed: {
    theme_switch() {
      return this.$store.state.theme_switch
    }
  }
}
</script>

<style lang="stylus" scoped>
.default-container
  padding: 120px 0;
  text-align: center;
  p
    font-size: 14px;
    line-height: 20px;
    commonColor(#BCBDC1, #999999)
    margin-top: 30px;
    a
      color: rgba(250, 122, 80, 1);
      text-decoration: underline;
</style>
